Vue.component("bi-plan-select",
    {
        template: "#vue-bi-plan-select",

        data()
        {
            return {
                additionalCosts: []
            };
        },

        methods: {
            /**
             * Navigation between pages
             * @param direction 'next' || 'back'
             */
            navAction(direction)
            {
                this.$emit("nav-action", direction);
            },

            setBiPlanModalDetails(technicalData)
            {
                this.$store.commit("setBiPlanModalData", technicalData);
            },

            hasConfigrationsAndDimensions(technicalData)
            {
                return technicalData !== "";
            },

            selectPlan(id)
            {
                this.$store.commit("setSelectedBiPlanItemId", id);
                this.navAction("next");
            },

            getMinimumContractTerm(biPlan)
            {
                const properties = biPlan.data.properties;

                for (const property of properties)
                {
                    if (property.property.names.name === "MinimumContractTerm")
                    {
                        return (property.valueInt > 0) ?
                            property.valueInt + " " + this.trans("months") :
                            this.trans("plentyBINoMinimumContractTerm");
                    }
                }
                return "-";
            },

            getMaximumOfKeyFigures(children)
            {
                for (const obj in children)
                {
                    const child = children[obj].data.variationProperties;

                    for (const variationProperties of child)
                    {
                        if (variationProperties.property.names.name === "max")
                        {
                            return variationProperties.values.value;
                        }
                    }
                }
                return "-";
            },

            getMaximumRawDataStorage(variationProperties)
            {
                for (const variation of variationProperties)
                {
                    if (variation.property.names.name === "RawDataStorageMonth")
                    {
                        return variation.values.value;
                    }
                }
                return "-";
            },

            costsPerKeyFigure(children)
            {
                for (const obj in children)
                {
                    return children[obj].data.price.priceNet;
                }
                return "-";
            },

            isBookable(availability)
            {
                return availability.indexOf(this.selectedContractType) > -1;
            },

            isActiveBiPlan(biPlan)
            {
                const properties = biPlan.data.properties;

                for (const property of properties)
                {
                    if (property.property.names.name === "ModuleValue")
                    {
                        return property.texts.value === this.activeBiPlanNumber;
                    }
                }
                return false;
            },

            ...Vuex.mapMutations(
                [
                    "setBiPlanModalData"
                ]
            )
        },

        computed: {
            ...Vuex.mapGetters(
                {
                    trans: "getTranslation",
                    activeBiPlanNumber: "getActiveBiPlan"
                }
            ),
            ...Vuex.mapState(
                {
                    biPlans: state => state.assistant.biPlans,
                    selectedContractType: state => state.assistant.selectedContractType
                }
            )
        }
    });
